// API Configuration - Updated to match native app structure
//export const API_URL = "https://hagd-admin.imperiatec.com";
//export const API_URL = "http://localhost:8000";
export const API_URL = "https://hagdstaging.welcomedata.com";
export const API_BASE_URL = `${API_URL}`;

// Import all API endpoints for local use
import { AUTH_ENDPOINTS } from "@/constants/api.auth";
import { APPOINTMENT_ENDPOINTS } from "@/constants/api.appointments";
import { EVENT_ENDPOINTS } from "@/constants/api.events";
import { MEETING_ENDPOINTS } from "@/constants/api.meetings";
import { CONCIERGE_ENDPOINTS } from "@/constants/api.concierge";
import { GYM_ENDPOINTS } from "@/constants/api.gym";
import { BEAUTY_ENDPOINTS } from "@/constants/api.beauty";
import { CALENDAR_ENDPOINTS } from "@/constants/api.calendar";
import { SERVICE_ENDPOINTS } from "@/constants/api.services";

// Combined export for backward compatibility (feed endpoints retirés côté web)
export const API_ENDPOINTS = {
  AUTH: AUTH_ENDPOINTS,
  APPOINTMENTS: APPOINTMENT_ENDPOINTS,
  EVENTS: EVENT_ENDPOINTS,
  MEETINGS: MEETING_ENDPOINTS,
  CONCIERGE: CONCIERGE_ENDPOINTS,
  GYM: GYM_ENDPOINTS,
  BEAUTY: BEAUTY_ENDPOINTS,
  CALENDAR: CALENDAR_ENDPOINTS,
  SERVICES: SERVICE_ENDPOINTS,
} as const;

// Request headers helper - Updated to match mobile app format
export const getAuthHeaders = (token: string) => ({
  "Content-Type": "application/json",
  Authorization: `token ${token}`, // DRF TokenAuthentication expects 'token <key>'
});

/** Authorization uniquement (ex. ``FormData`` : ne pas fixer ``Content-Type``). */
export const getAuthHeadersMultipart = (token: string) => ({
  Authorization: `token ${token}`,
});

// Base request headers
export const getBaseHeaders = () => ({
  "Content-Type": "application/json",
});
